/**
 * JourneyHistoryPage — route entry for the admin Journey History & Stop
 * Points module (ODE-P07-T06). Applies the client-side permission mirror
 * (UX only — the server-side OD-015 `journey.view` guard on every P04-T09
 * endpoint remains the authority) and renders the module. Test seams are
 * passed through (no real fetch in tests).
 *
 * Traces to: ODE-PRD-REQ-046, ODE-PRD-REQ-077, ODE-PRD-REQ-090
 */

import { useAuth } from '../../auth/AuthContext.js';
import { StateView } from '../../components/StateView.js';
import { hasPermission } from '../../rbac/catalog.js';
import { JourneyHistoryModule, type JourneyHistorySeams } from './JourneyHistoryModule.js';

export function JourneyHistoryPage({
  seams,
}: { readonly seams?: JourneyHistorySeams } = {}): JSX.Element {
  const { session } = useAuth();
  const allowed = session !== null && hasPermission(session.staff.roles, 'journey.view');
  if (!allowed) {
    return (
      <StateView
        state={{
          kind: 'blocked',
          message: 'Peran tidak memiliki izin journey.view untuk halaman ini.',
        }}
      />
    );
  }
  return <JourneyHistoryModule seams={seams ?? {}} />;
}
